import React from 'react'
import CSSModules from 'react-css-modules'
import { localize } from 'helpers/translator'

import Isvg from 'react-inlinesvg'
import styles from './picker_search_no_results.scss'

import NoResultsSvg from 'assets/components/nearpod_picker/youtube-no-results.svg'

const PickerSearchNoResults = () => (
	<div styleName='wrapper'>
		<h3 styleName='title'>{localize('picker_search_youtube_noresults_title')}</h3>
		<p styleName='message'>{localize('picker_search_youtube_noresults_message')}</p>
		<Isvg src={NoResultsSvg} cacheGetRequests={true} styleName='img-no-result'/>
	</div>
)

export default CSSModules(PickerSearchNoResults, styles, {allowMultiple: true})
